import React, { useEffect, useState } from 'react'
import { getImage } from '../../services/image'
import { connect } from 'react-redux'

import './index.css'

const Image = props => {
  const [image, setImage] = useState(null)
    , { access_token } = props.settings
    , {
      onClick = () => null
    } = props
  useEffect(() => {

    setImage(null)

    if (props.fromCMS) return setImage(props.src)

    getImage(access_token, props.src)
      .then(res => {
        setImage(res)
      })
      .catch(err => console.log(err))
    return () => {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.src])

  return <div onClick={onClick} className={`image__container ${image == null ? 'image__base' : ''} ${props.className}`}>
    {
      typeof props.src === 'string' && image &&
      <img className='image__container-src' src={image} alt={props.src} />
    }
  </div>
}

const mapStateToProps = state => ({
  settings: state.settings,
})

export default connect(mapStateToProps)(Image)